import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./registerServiceWorker";
import store from "./store";
import happroxy from "./filters/happroxy";
import VueNotification from "@kugatsu/vuenotification";
import VueLazyload from 'vue-lazyload';
import config from "./config";
import firebase from "firebase";
import Lightbox from 'vue-my-photos'
import 'vue-search-select/dist/VueSearchSelect.css'
import Vue2Editor from "vue2-editor";


firebase.initializeApp(config.firebaseConfig);

Vue.filter("happroxy", function(value) {
  if (!value) return "";
  return happroxy(value);
});

Vue.use(VueNotification, {
  timer: 5
});

Vue.use(VueLazyload, {
  observer: true
});

Vue.component('lightbox', Lightbox);
Vue.use(Lightbox);
Vue.use(Vue2Editor);


import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: config.GMapKey,
    libraries: "places"
  },
  installComponents: true
})

Vue.config.productionTip = false;

Vue.config.ignoredElements = [/ion-\w*/];

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
